export const GET_ARTICLE_HOME_LIST = "GET_ARTICLE_HOME_LIST"
export const GET_ARTICLE_HOME_LIST_FAIL = "GET_ARTICLE_HOME_LIST_FAIL"
export const GET_ARTICLE_HOME_LIST_SUCCESS = "GET_ARTICLE_HOME_LIST_SUCCESS"
export const GET_ARTICLE_HOME_LIST_RESET = "GET_ARTICLE_HOME_LIST_RESET"

export const getArticleHomeList = (params) => {
    return { type: GET_ARTICLE_HOME_LIST, params }
}
export const getArticleHomeListFail = (response) => {
    return { type: GET_ARTICLE_HOME_LIST_FAIL, response }
}
export const getArticleHomeListSuccess = (response) => {
    return { type: GET_ARTICLE_HOME_LIST_SUCCESS, response }
}
export const getArticleHomeListReset = () => {
    return { type: GET_ARTICLE_HOME_LIST_RESET }
}